import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import UserService from '../../../../services/users-auth';
import { Link } from 'react-router-dom';


const Fiscal = () => {
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [nivel, setNivel] = useState("");
    const [senha, setSenha] = useState("");

    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);




    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const fiscal = await UserService.cadastro({
                nome_fiscal: nome,
                email: email,
                nivel: nivel,
                senha: senha
            })
            if (fiscal.data["cod_fiscal"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("")
        setEmail("")
        setSenha("")
        setNivel("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="email">
                                <FloatingLabel
                                    label="E-mail"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="senha">
                                <FloatingLabel
                                    label="Senha"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="senha"
                                        value={senha}
                                        onChange={e => setSenha(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="nivel">
                                <FloatingLabel
                                    label="Nível"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="nivel"
                                        name="nivel"
                                        onChange={e => setNivel(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Legislador">Legislador</option>
                                        <option value="Licitador">Licitador</option>
                                        <option value="Administrador">Administrador</option>
                                        <option value="Controle Interno">Controle Interno</option>
                                        <option value="Saude">Saude</option>
                                        <option value="Educação">Educação</option>
                                        <option value="Obras">Obras</option>
                                        <option value="RH">RH</option>
                                        <option value="Ouvidor">Ouvidor</option>
                                        <option value="Diario">Diario</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/usuarios'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Fiscal cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/usuarios/listar'}>
                    <Button variant="primary" type="button">
                        Ver Fiscais Cadastrados
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/usuarios'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Fiscal;